<template>
  <vs-select
    class="w-full"
    label="Billing Cycle (month)"
    v-model="selected"
  >
    <vs-select-item
      :key="index"
      :value="item"
      :text="item"
      v-for="(item, index) in 12"
    />
  </vs-select>
</template>

<script>
export default {
  props: {
    data: {
      type: Number,
      default: 0
    }
  },
  computed: {
    selected: {
      get() {
        return this.data
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  }
}
</script>
